import { luigiMediaArray } from './luigiMedia'
import { luigiBio } from './luigiBios'
import { frodoProfileReviewHinge, hollyProfileReviewBumble, gatsbyProfileReviewTinder } from './luigiProfileReviews'

export const luigiDatingProfileHinge = {
  _id: 'luigiDatingProfileHingeId',
  userId: 'luigiUserId',
  email: 'luigi@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: luigiMediaArray[1]._id,
      mediaItemURL: luigiMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[1].type,
      caption: luigiMediaArray[1].captions[0],
      subcaption: luigiMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[6]._id,
      mediaItemURL: luigiMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[6].type,
      caption: luigiMediaArray[6].captions[0],
      subcaption: luigiMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[4]._id,
      mediaItemURL: luigiMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[4].type,
      caption: luigiMediaArray[4].captions[0],
      subcaption: luigiMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[18]._id,
      mediaItemURL: luigiMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[18].type,
      caption: luigiMediaArray[18].captions[0],
      subcaption: luigiMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[25]._id,
      mediaItemURL: luigiMediaArray[25].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[25].type,
      caption: luigiMediaArray[25].captions[0],
      subcaption: luigiMediaArray[25].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[12]._id,
      mediaItemURL: luigiMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[12].type,
      caption: luigiMediaArray[12].captions[0],
      subcaption: luigiMediaArray[12].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: luigiBio._id,
    vitalInfo: { ...luigiBio.vitalInfo },
    prompts: [
      { ...luigiBio.prompts[0] },
      { ...luigiBio.prompts[1] },
      { ...luigiBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...frodoProfileReviewHinge }
  ],
  mediaItems: [ ...luigiMediaArray ],
  bioItems: { ...luigiBio },
}

export const luigiDatingProfileBumble = {
  _id: 'luigiDatingProfileBumbleId',
  userId: 'luigiUserId',
  email: 'luigi@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: luigiMediaArray[1]._id,
      mediaItemURL: luigiMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[1].type,
      caption: luigiMediaArray[1].captions[0],
      subcaption: luigiMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[6]._id,
      mediaItemURL: luigiMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[6].type,
      caption: luigiMediaArray[6].captions[0],
      subcaption: luigiMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[4]._id,
      mediaItemURL: luigiMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[4].type,
      caption: luigiMediaArray[4].captions[0],
      subcaption: luigiMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[18]._id,
      mediaItemURL: luigiMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[18].type,
      caption: luigiMediaArray[18].captions[0],
      subcaption: luigiMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[25]._id,
      mediaItemURL: luigiMediaArray[25].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[25].type,
      caption: luigiMediaArray[25].captions[0],
      subcaption: luigiMediaArray[25].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[12]._id,
      mediaItemURL: luigiMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[12].type,
      caption: luigiMediaArray[12].captions[0],
      subcaption: luigiMediaArray[12].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: luigiBio._id,
    vitalInfo: { ...luigiBio.vitalInfo },
    prompts: [
      { ...luigiBio.prompts[0] },
      { ...luigiBio.prompts[1] },
      { ...luigiBio.prompts[2] }
    ],
    aboutMe: luigiBio.aboutMe[0],
    hobbies: [luigiBio.hobbies[0], luigiBio.hobbies[1], luigiBio.hobbies[2], luigiBio.hobbies[3], luigiBio.hobbies[4] ],
  },
  profileReviews: [
    { ...hollyProfileReviewBumble }
  ],
  mediaItems: [ ...luigiMediaArray ],
  bioItems: { ...luigiBio },
}

export const luigiDatingProfileTinder = {
  _id: 'luigiDatingProfileTinderId',
  userId: 'luigiUserId',
  email: 'luigi@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: luigiMediaArray[1]._id,
      mediaItemURL: luigiMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[1].type,
      caption: luigiMediaArray[1].captions[0],
      subcaption: luigiMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[6]._id,
      mediaItemURL: luigiMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[6].type,
      caption: luigiMediaArray[6].captions[0],
      subcaption: luigiMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[4]._id,
      mediaItemURL: luigiMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[4].type,
      caption: luigiMediaArray[4].captions[0],
      subcaption: luigiMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[18]._id,
      mediaItemURL: luigiMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[18].type,
      caption: luigiMediaArray[18].captions[0],
      subcaption: luigiMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[25]._id,
      mediaItemURL: luigiMediaArray[25].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[25].type,
      caption: luigiMediaArray[25].captions[0],
      subcaption: luigiMediaArray[25].subcaptions[0],
    },
    {
      mediaItemId: luigiMediaArray[12]._id,
      mediaItemURL: luigiMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: luigiMediaArray[12].type,
      caption: luigiMediaArray[12].captions[0],
      subcaption: luigiMediaArray[12].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: luigiBio._id,
    vitalInfo: { ...luigiBio.vitalInfo },
    prompts: [
      { ...luigiBio.prompts[0] },
      { ...luigiBio.prompts[1] },
      { ...luigiBio.prompts[2] }
    ],
    aboutMe: luigiBio.aboutMe[0],
    hobbies: [luigiBio.hobbies[0], luigiBio.hobbies[1], luigiBio.hobbies[2], luigiBio.hobbies[3], luigiBio.hobbies[4] ],
  },
  profileReviews: [
    { ...gatsbyProfileReviewTinder }
  ],
  mediaItems: [ ...luigiMediaArray ],
  bioItems: { ...luigiBio },
}